import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a9e2f85"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title1" }
const _hoisted_2 = {
  key: 0,
  class: "coreCnetent"
}
const _hoisted_3 = {
  key: 1,
  class: "coreCnetent"
}

import { computed } from "vue";
import { useStore } from "vuex";
import ZhCoreFunctionsTab1 from "./ZhCoreFunctionsTab1.vue";
import ZhCoreFunctionsTab2 from "./ZhCoreFunctionsTab2.vue";
import EnCoreFunctionsTab1 from "./EnCoreFunctionsTab1.vue";
import EnCoreFunctionsTab2 from "./EnCoreFunctionsTab2.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CoreFunctions',
  setup(__props) {

const store = useStore();
const appLanguage = computed(() => store.state.appLanguage);
const isMobile = computed(() => !!store.state.isMobile as boolean);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['core', 'core-' + _unref(appLanguage), { mobileSize: _unref(isMobile) }])
  }, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t("home.core_funs")), 1),
    (_unref(appLanguage) === 'zh')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ZhCoreFunctionsTab1),
          _createVNode(ZhCoreFunctionsTab2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(EnCoreFunctionsTab1),
          _createVNode(EnCoreFunctionsTab2)
        ]))
  ], 2))
}
}

})